// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"61313610","453":"089e22ff","455":"f8784297","977":"7297c2cc"}[chunkId] + ".chunk.js";
};